module.exports = __webpack_public_path__ + "static/media/dec-qr-code.36f05e96.png";